/**
 * Custom initialization module for Pendo. Designed to ease the application of Pendo's requirements.
 *
 * {@link https://help.pendo.io/resources/support-library/installation/metadata.html Pendo Support on Metadata} states:
 * "There are data syntax rules you will need to follow in order for Pendo to receive all of your data: Do not send null
 * values for any fields. If you do not have data for a field omit sending that field. Any custom fields added in the
 * snippet cannot include a space."
 *
 * @module "lib/pendo.initializer"
 */
define('fukit/lib/pendo.initializer',['require','exports','module','underscore','../config'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      config    = require('../config');

  var isNil = function(o) {
    return _.isUndefined(o) || _.isNull(o);
  };

  var addPropIfValueExists = function(pendoObject, propName, value) {
    if (!isNil(value)) {
      pendoObject[propName] = value;
    } else {
      console.warn(
        'Property "' +
          propName +
          '" will not be added to Pendo metadata because the value it would have is `' +
          value +
          '`.'
      );
    }
  };

  var safeGetPersonEmail = function(personPrincipalModel) {
    var email = null;
    if (personPrincipalModel.get('user.email')) {
      try {
        email = personPrincipalModel.get('user.email');
      } catch (e) {
        console.error('Unable to retrieve email address for Pendo metadata.\n', e);
      }
    }

    return email;
  };

  var safeGetUserGroups = function(userGroups) {
    var groupsCollection = null;
    if (userGroups) {
      try {
        groupsCollection = userGroups;
      } catch (e) {
        console.error('Unable to retrieve user groups for Pendo metadata.\n', e);
      }
      return groupsCollection;
    }
  };

  module.exports = {
    initialize: function(personPrincipalModel, groups) {
      ////////// Prepare Visitor metadata //////////
      var pendoVisitor = {
        id: personPrincipalModel.get('user.id'), // Required if user is logged in
      };
      addPropIfValueExists(pendoVisitor, 'email', safeGetPersonEmail(personPrincipalModel));
      addPropIfValueExists(pendoVisitor, 'roles', safeGetUserGroups(groups));

      ////////// Prepare Account metadata //////////
      var pendoAccount = {
        product: config.get('pendo.product'), // Custom
        id: location.hostname,
      };

      try {
        pendo.initialize({
          visitor: pendoVisitor,
          account: pendoAccount,
        });
      } catch (e) {
        console.error('Error initializing Pendo. Ensure Pendo is properly installed.\n', e);
      }
    },
  };
});

